import React from 'react';
import DateTime from "../DateTime/DateTime";
import "./asset-activity-status.scss";
import ActivityStatus from "../../../../data/ActivityStatus";
export default function AssetActivityStatus(props) {
    var status = '';
    switch (props.asset.activityStatus) {
        case ActivityStatus.NONE:
            status = 'danger';
            break;
        case ActivityStatus.EXPIRED:
            status = 'warning';
            break;
        case ActivityStatus.RECENT:
            status = 'success';
            break;
    }
    return React.createElement("div", { className: 'asset-activity-status w-100 d-flex align-items-center asset-activity-status--' + status },
        React.createElement("div", { className: "asset-activity-status__indicator mr-3" }),
        React.createElement("div", { className: "asset-activity-status__date" },
            React.createElement(DateTime, { date: props.asset.lastConnectedDateTime, compact: true })));
}
